import {useSearchParams} from "react-router-dom";
import {useGetMeasurementUnitQuery} from "../../store/backend-api/backend.api";
import React, {useEffect, useState} from "react";
import {MeasurementUnitFormEdit} from "../../components/measurement-unit/form/MeasuremetUnitFormEdit";

export function EditMeasurementUnitForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetMeasurementUnitQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && (<MeasurementUnitFormEdit data={data}/>)}
    </div>)
}